import profile6 from "../assets/bckg13.jpg"
import profile2 from "../assets/bckg10.jpg"
import profile3 from "../assets/bckg6.jpg"
import profile4 from "../assets/bckg15.jpg"
import profile5 from "../assets/bckg22.jpg"

  
  const Onlinedata = [
    {
        id: 11,
        profileimg: profile6,
        friendname: "Amanda Fischi",
        online: true,
        title: "News Anchor"
    },
    {
        id: 12,
        profileimg: profile2,
        friendname: "Erza Scralet",
        online: false,
        title: "Web Developer"
        
    },
    {
        id: 13,
        profileimg: profile3,
        friendname: "Krish Sampi",
        online: true,
        title: "Tourist"
    },
    {
        id: 14,
        profileimg: profile4,
        friendname: "Yae Yushiko",
        online:true,
        title: "Content Writer"
    },
    {
        id: 15,
        profileimg: profile5,
        friendname: "  Samuel Bright ",
        online: true,
        title: "Journalist"
    },
]

export default Onlinedata;